import useModalStore from '@/stores/modal/modalStore';
import DModalPlans from '@/components/DModalPlans';
import {
  MODAL_VARIANT_FREE_TO_STARTER,
  MODAL_VARIANT_STARTER_TO_ADVANCED,
  MODAL_VARIANT_ADVANCED_TO_PRO,
  MODAL_VARIANT_PRO_TO_ENTERPRISE,
} from '@/helpers/tier/upgradeConfig';
import FreeToStarterModal from './FreeToStarterModal';
import StarterToAdvancedModal from './StarterToAdvancedModal';
import AdvancedToProModal from './AdvancedToProModal';
import ProToEnterpriseModal from './ProToEnterpriseModal';

/**
 * Renders the appropriate upgrade modal based on modalStore state.
 * When modalVariant is set (from feature gate or openUpgradeModal), shows the path-specific modal;
 * otherwise falls back to the full DModalPlans experience.
 */
const UpgradeModalManager = ({ removeBackdrop = false }) => {
  const {
    showPlans,
    closePlansModal,
    upgradeContext,
    modalVariant,
    currentFeature,
    currentFeatureTitle,
  } = useModalStore();

  const commonProps = {
    isOpen: showPlans,
    onClose: closePlansModal,
    feature: currentFeature ?? upgradeContext?.feature,
    currentFeatureTitle,
    currentTier: upgradeContext?.currentTier,
    targetTier: upgradeContext?.targetTier,
  };

  if (modalVariant === MODAL_VARIANT_FREE_TO_STARTER) {
    return <FreeToStarterModal {...commonProps} />;
  }

  if (modalVariant === MODAL_VARIANT_STARTER_TO_ADVANCED) {
    return <StarterToAdvancedModal {...commonProps} />;
  }

  if (modalVariant === MODAL_VARIANT_ADVANCED_TO_PRO) {
    return <AdvancedToProModal {...commonProps} />;
  }

  if (modalVariant === MODAL_VARIANT_PRO_TO_ENTERPRISE) {
    return <ProToEnterpriseModal {...commonProps} />;
  }

  return (
    <DModalPlans
      isOpen={showPlans}
      onClose={closePlansModal}
      highlightedFeature={currentFeature}
      title={currentFeatureTitle}
      subtitle="Your premium feature is one click away. No minimum contract, cancel at anytime."
      removeBackdrop={removeBackdrop}
    />
  );
};

export default UpgradeModalManager;
